module.exports = __webpack_public_path__ + "img/20.4801942f.webp";